import { isEmpty } from 'remeda'
import { ThemeProvider } from 'styled-components'
import { Hero } from '@components/Hero/Hero'
import { getThemeByBrand } from '@velasca/utils/get-theme-by-brand'
import { BlockLayout } from './BlockLayout/BlockLayout'
import { Blocks } from './LookbookPage.styles'
import type { LookbookPageProps } from './LookbookPage.types'
import { LookItem } from './LookItem/LookItem'

export const LookbookPage = ({
  blocks,
  heroProps,
  pageGeneralOptions,
}: LookbookPageProps) => {
  const {
    drawer_title: drawerTitle,
    popup_title: popupTitle,
    popup_subtitle: popupSubtitle,
    brand,
  } = pageGeneralOptions

  return (
    <ThemeProvider theme={getThemeByBrand(brand)}>
      {/* @ts-expect-error */}
      {!isEmpty(heroProps) && <Hero {...heroProps} />}
      <Blocks>
        {blocks.map(
          ({
            id,
            looks,
            upperTitle,
            title: blockTitle,
            description,
            layoutType,
          }) => {
            return (
              <BlockLayout
                key={id}
                layout={layoutType}
                upperTitle={upperTitle}
                title={blockTitle}
                description={description || ''}
              >
                {looks.map((look, i) => {
                  return (
                    <LookItem
                      key={i}
                      position={i}
                      look={look}
                      layoutType={layoutType}
                      drawerTitle={drawerTitle}
                      popupTitle={popupTitle}
                      popupSubtitle={popupSubtitle}
                    />
                  )
                })}
              </BlockLayout>
            )
          },
        )}
      </Blocks>
    </ThemeProvider>
  )
}
